import {
    GETROLEDROPLISTFORDEALER_SUCCESS,
    GETROLEDROPLISTFORDEALER_FAILED,
    RESET_GETROLEDROPLISTFORDEALER,
    LOADING_GETROLEDROPLISTFORDEALER,
    NETWORK_ERROR_GETROLEDROPLISTFORDEALER,
} from "../types/index";

import { dealerServices } from "../../config/axios";



const resetGetRoleDropListForDealer = () => {
    return { type: RESET_GETROLEDROPLISTFORDEALER };
};

const getRoleDropListsForDealer = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETROLEDROPLISTFORDEALER });
    await dealerServices
        .post("getDEALERRoleDropList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getRoleDropListDealersuccess(res.data));
                    break;
                default:
                    dispatch(getRoleDropListDealerFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETROLEDROPLISTFORDEALER, payload: err });
        });
};
function getRoleDropListDealersuccess(data) {
    return {
        type: GETROLEDROPLISTFORDEALER_SUCCESS,
        payload: data,
    };
}
function getRoleDropListDealerFailed(data) {
    return {
        type: GETROLEDROPLISTFORDEALER_FAILED,
        payload: data,
    };
}

export { resetGetRoleDropListForDealer, getRoleDropListsForDealer };
